import { combineReducers } from 'redux';
import sarimaReducer from './sarima';

export default combineReducers({
  sarima: sarimaReducer
});
